
import { ExamSession, BackendQuestion, QuestionDifficulty, ExamConfig } from '../types';

export const US_STATES = [
    { code: 'Global', name: 'Universal Standard', vendor: 'Academic Prep' },
    { code: 'AL', name: 'Alabama', vendor: 'Prometric' }, { code: 'AK', name: 'Alaska', vendor: 'Credentia' },
    { code: 'AZ', name: 'Arizona', vendor: 'D&S Headmaster' }, { code: 'AR', name: 'Arkansas', vendor: 'Prometric' },
    { code: 'CA', name: 'California', vendor: 'Headmaster' }, { code: 'CO', name: 'Colorado', vendor: 'Credentia' },
    { code: 'CT', name: 'Connecticut', vendor: 'Prometric' }, { code: 'DE', name: 'Delaware', vendor: 'Prometric' },
    { code: 'FL', name: 'Florida', vendor: 'Prometric' }, { code: 'GA', name: 'Georgia', vendor: 'Credentia' },
    { code: 'HI', name: 'Hawaii', vendor: 'Prometric' }, { code: 'ID', name: 'Idaho', vendor: 'Prometric' },
    { code: 'IL', name: 'Illinois', vendor: 'Southern Illinois Univ' }, { code: 'IN', name: 'Indiana', vendor: 'Ivy Tech' },
    { code: 'IA', name: 'Iowa', vendor: 'Community College' }, { code: 'KS', name: 'Kansas', vendor: 'KDADS' },
    { code: 'KY', name: 'Kentucky', vendor: 'KCTCS' }, { code: 'LA', name: 'Louisiana', vendor: 'Prometric' },
    { code: 'ME', name: 'Maine', vendor: 'D&S Headmaster' }, { code: 'MD', name: 'Maryland', vendor: 'GNA' },
    { code: 'MA', name: 'Massachusetts', vendor: 'D&S Headmaster' }, { code: 'MI', name: 'Michigan', vendor: 'Prometric' },
    { code: 'MN', name: 'Minnesota', vendor: 'Headmaster' }, { code: 'MS', name: 'Mississippi', vendor: 'Credentia' },
    { code: 'MO', name: 'Missouri', vendor: 'D&S Headmaster' }, { code: 'MT', name: 'Montana', vendor: 'D&S Headmaster' },
    { code: 'NE', name: 'Nebraska', vendor: 'Prometric' }, { code: 'NV', name: 'Nevada', vendor: 'Headmaster' },
    { code: 'NH', name: 'New Hampshire', vendor: 'LNA' }, { code: 'NJ', name: 'New Jersey', vendor: 'PSI' },
    { code: 'NM', name: 'New Mexico', vendor: 'Prometric' }, { code: 'NY', name: 'New York', vendor: 'Prometric' },
    { code: 'NC', name: 'North Carolina', vendor: 'Credentia' }, { code: 'ND', name: 'North Dakota', vendor: 'D&S Headmaster' },
    { code: 'OH', name: 'Ohio', vendor: 'D&S Headmaster' }, { code: 'OK', name: 'Oklahoma', vendor: 'Prometric' },
    { code: 'OR', name: 'Oregon', vendor: 'Headmaster' }, { code: 'PA', name: 'Pennsylvania', vendor: 'Credentia' },
    { code: 'RI', name: 'Rhode Island', vendor: 'Prometric' }, { code: 'SC', name: 'South Carolina', vendor: 'Credentia' },
    { code: 'SD', name: 'South Dakota', vendor: 'D&S Headmaster' }, { code: 'TN', name: 'Tennessee', vendor: 'D&S Headmaster' },
    { code: 'TX', name: 'Texas', vendor: 'Credentia' }, { code: 'UT', name: 'Utah', vendor: 'D&S Headmaster' },
    { code: 'VT', name: 'Vermont', vendor: 'Prometric' }, { code: 'VA', name: 'Virginia', vendor: 'Credentia' },
    { code: 'WA', name: 'Washington', vendor: 'Credentia' }, { code: 'WV', name: 'West Virginia', vendor: 'Professional Healthcare' },
    { code: 'WI', name: 'Wisconsin', vendor: 'Headmaster' }, { code: 'WY', name: 'Wyoming', vendor: 'Prometric' }
];

export const CNA_DOMAINS = [
    'Vital Signs',
    'Basic Nursing Skills',
    'Personal Care Skills',
    'Restorative Skills',
    'Infection Control',
    'Safety & Emergency Procedures',
    'Resident Rights',
    'Communication & Interpersonal Skills',
    'Role of the Nurse Aide',
    'Legal & Ethical Behavior',
    'Mental Health Needs',
    'Cognitive Impairment Care',
    'End of Life Care',
    'Data Collection & Reporting',
    'Clinical Scenarios',
    'Activities of Daily Living'
];

const STATE_CONFIGS_FALLBACK: Record<string, ExamConfig> = {
    'FL': { state: 'FL', vendor: 'Prometric', timeLimitMinutes: 120, passingPercent: 75, totalQuestions: 60 },
    'CA': { state: 'CA', vendor: 'Headmaster', timeLimitMinutes: 90, passingPercent: 75, totalQuestions: 75 },
    'TX': { state: 'TX', vendor: 'Credentia', timeLimitMinutes: 120, passingPercent: 72, totalQuestions: 70 },
    'NY': { state: 'NY', vendor: 'Prometric', timeLimitMinutes: 120, passingPercent: 75, totalQuestions: 60 },
    'Global': { state: 'Global', vendor: 'Academic Prep', timeLimitMinutes: 120, passingPercent: 80, totalQuestions: 70 }
};

// Export MOCK_POOL to resolve import error in services/missedQuestionsService.ts
export const MOCK_POOL: BackendQuestion[] = [
    {
      _id: "mock_q1",
      type: 'multiple-choice',
      text: "A resident typically sleeps in a curled position. When getting the resident out of bed, the nurse aide SHOULD:",
      category: "Basic Nursing Skills",
      difficulty: "Medium",
      options: [
        { _id: "o1", text: "Pull the resident up in bed before moving them.", isCorrect: false },
        { _id: "o2", text: "Sit the resident on the edge of the bed to wait for dizziness to pass.", isCorrect: true },
        { _id: "o3", text: "Immediately help the resident to a standing position.", isCorrect: false },
        { _id: "o4", text: "Ask the resident to straighten their legs while lying down.", isCorrect: false }
      ],
      explanation: "Orthostatic hypotension can occur when changing positions. Sitting allows the body to adjust.",
      vendorTags: ["Global"]
    },
    {
      _id: "mock_order_1",
      type: 'ordering',
      text: "Place the following handwashing steps in the correct clinical sequence:",
      category: "Infection Control",
      difficulty: "Hard",
      options: [
        { _id: "s1", text: "Wet hands and wrists thoroughly under running water." },
        { _id: "s2", text: "Apply soap to hands." },
        { _id: "s3", text: "Lather all surfaces of hands and fingers for at least 20 seconds." },
        { _id: "s4", text: "Clean under fingernails." },
        { _id: "s5", text: "Rinse hands and wrists under running water." }
      ],
      explanation: "Proper hand hygiene sequence is critical: water first, then soap, friction for 20s, fingernail care, and final rinse.",
      vendorTags: ["Global"]
    }
];

export const getMockSession = (certId: string, stateCode: string, options: any = {}): ExamSession => {
  const { difficulty = 'Medium', exclusive = false, passingPercent, totalQuestions } = options;
  const baseConfig = STATE_CONFIGS_FALLBACK[stateCode] || STATE_CONFIGS_FALLBACK['Global'];
  
  const config: ExamConfig = {
      ...baseConfig,
      difficulty,
      passingPercent: passingPercent ?? baseConfig.passingPercent,
      totalQuestions: totalQuestions ?? baseConfig.totalQuestions
  };

  const questions: BackendQuestion[] = [];
  
  if (certId === 'cna' || !certId) {
      for (let i = 0; i < config.totalQuestions; i++) {
          const baseQ = MOCK_POOL[i % MOCK_POOL.length];
          questions.push({
              ...baseQ,
              _id: `${baseQ._id}_inst_${i}` 
          });
      }
  }

  return {
    examConfig: config,
    questions: questions
  };
};

export const getPracticeQuestions = (certId: string, topic: string, count: number, stateFilter: string = 'All', difficulty: QuestionDifficulty = 'Medium', exclusive: boolean = false): BackendQuestion[] => {
  if (certId !== 'cna' && certId !== '') return [];

  let pool = [...MOCK_POOL];
  
  // 1. Strictly filter by category first if a specific topic is requested
  const isMixed = ['Mixed', 'Mixed Domain', 'Mixed Domain Exam', 'Mixed Scenarios', 'All'].includes(topic);
  
  if (!isMixed && topic !== 'Missed Questions') {
      pool = pool.filter(q => q.category === topic);
  }

  // 2. LOGICAL UNION: Match specific state OR Global (empty tags)
  if (stateFilter !== 'All' && stateFilter !== 'Global') {
      const stateSpecific = pool.filter(q => q.stateSpecificTags?.includes(stateFilter));
      const compatibleGlobal = pool.filter(q => !q.stateSpecificTags || q.stateSpecificTags.length === 0);
      
      if (exclusive) {
          pool = stateSpecific;
      } else {
          // EXCLUSIONARY LOGIC: We exclude items tagged for OTHER states
          // This keeps only the specific match and universal items
          pool = [...stateSpecific, ...compatibleGlobal];
      }
  } else if (stateFilter === 'Global') {
      // Return only universal items
      pool = pool.filter(q => !q.stateSpecificTags || q.stateSpecificTags.length === 0);
  }

  // 3. Fallback: only if pool is empty AND we are in mixed mode should we reset to the full mock pool
  if (pool.length === 0 && isMixed) {
      pool = [...MOCK_POOL];
  }
  
  const shuffledPool = [...pool].sort(() => 0.5 - Math.random());
  const results: BackendQuestion[] = [];
  
  if (shuffledPool.length > 0) {
      for (let i = 0; i < count; i++) {
        const original = shuffledPool[i % shuffledPool.length];
        results.push({
          ...original,
          _id: `${original._id}_prac_${i}_${Math.random().toString(36).substr(2, 5)}`
        });
      }
  }
  
  return results;
};

export const getStateConfig = (code: string) => STATE_CONFIGS_FALLBACK[code] || STATE_CONFIGS_FALLBACK['Global'];
